import { useMemo } from "react";

interface RecipeData {
  ingredientList: any[];
  processList: any[];
  processId: string;
}

interface UseRecipeFormValuesProps {
  recipeData: RecipeData;
  nodeItem: any;
  processId: string;
  recipeId: string;
  type: string;
  accordionEnabled: boolean;
}

/**
 * Custom hook for managing form values structure
 * Follows Single Responsibility Principle - handles form value mapping
 */
export const useRecipeFormValues = ({
  recipeData,
  nodeItem,
  processId,
  recipeId,
  type,
  accordionEnabled
}: UseRecipeFormValuesProps) => {
  const values = useMemo(() => {
    const formValues: any = {
      recipeData: recipeData,
      nodeItem,
      processId,
      recipeId,
      type
    };

    // Add process values to match field names
    recipeData.processList?.forEach((process: any) => {
      const pId = process.data?.reference?.processId;
      if (pId) {
        formValues[`process-${pId}`] = { value: process.value || "" };
      }
    });

    // Add ingredient values to match field names
    recipeData.ingredientList?.forEach((ingredient: any) => {
      const ingId = ingredient.data?.reference?.ingredientId;
      const supplierId = ingredient.data?.reference?.supplierId;
      if (ingId && supplierId) {
        formValues[`ingredient-${supplierId}-${ingId}`] = { value: ingredient.value || "" };
      }
    });

    return formValues;
  }, [accordionEnabled, recipeData, nodeItem, processId, recipeId, type]);

  return values;
};
